import e from"../colors/index.js";var l={colors:{accessibility:e.blue[300],selectedDay:e.blue[300],selectedDayHover:e.blue[400],primaryColor:e.blue[500]}};export{l as default};
